import type { DocumentCountsModel } from '@libs/services/models';
import { Observable } from 'rxjs';

export abstract class DocumentsSummary {
  public abstract getDocumentCounts(): Observable<DocumentCountsModel>;
}
